import { useState } from 'react';

import { useOnDurationChanged } from '@/scenarios/legacy-player/hooks/useOnDurationChanged';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

export const useDuration = () => {
    const instance = usePlayerInstance();
    const [duration, setDuration] = useState<number>(() => instance?.duration || 0);

    useOnDurationChanged(setDuration);

    return duration;
};
